import QuizGame from './QuizGame';

export default QuizGame;
